import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';

export class BuyFeatureButtonShowUIAct extends SyncUIActDecorator {
    public execute(): void {
        this.emitter.emit('Game.command.buyFeature.show');
        this.onExecuted?.();
    }

    getName(): string {
        return 'BuyFeatureButtonDisableUIAct';
    }
}